var map = {
	"./announce.svg": "e4a0",
	"./arrow.svg": "9718",
	"./award.svg": "72f3",
	"./close.svg": "f59d",
	"./collect.svg": "e70e",
	"./collect_a.svg": "f45d",
	"./discuss.svg": "d4ec",
	"./discuss_a.svg": "83d7",
	"./draft.svg": "cdac",
	"./draft_a.svg": "e8b6",
	"./eye-open.svg": "51b8",
	"./eye.svg": "760f",
	"./message.svg": "ed3f",
	"./message_a.svg": "5cfd",
	"./play.svg": "3b2c",
	"./post.svg": "05f1",
	"./post_a.svg": "eb4c",
	"./refuse.svg": "1d26",
	"./reply.svg": "241e",
	"./search.svg": "faca",
	"./share.svg": "a743",
	"./shield.svg": "85bd",
	"./shield_a.svg": "bbd9",
	"./sign.svg": "d9c3",
	"./sign_a.svg": "4f17",
	"./sword.svg": "3167",
	"./sword_a.svg": "c922",
	"./sword_v.svg": "a1b0",
	"./wechat.svg": "0b07",
	"./write.svg": "9b31",
	"./write_a.svg": "d9b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a82a";